import React, { useState, useEffect } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import appConfig from "../../../config";
import { useSelector } from "react-redux";
import { Footer, HeroSm, NavBar, Spinner } from "../../../components";
import { Slang } from "../../../helpers";

const StripePayment = () => {
  const lang = Slang("navbar");
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);

  // State variables for error handling, loading state, and initial loading
  const [paymentError, setPaymentError] = useState(null);
  const [isPaymentLoading, setPaymentLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Add initial loading state

  // Fetch payment information from local storage on component mount
  useEffect(() => {
    const paymentInfosString = localStorage.getItem("paymentInfos");
    if (paymentInfosString) {
      const paymentInfos = JSON.parse(paymentInfosString);
      console.log("paymentInfos", paymentInfos);
      // Set the secret key for Stripe
      //   stripe.setPublishableKey(paymentInfos.secret_key);
      setIsLoading(false); // Set initial loading to false if payment info is found
    } else {
      // Redirect to cart if payment information is not found
      navigate("/market-place/cart");
    }
  }, [stripe, navigate]);

  // Handle form submission for payment
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    setPaymentLoading(true);

    // Retrieve payment information from local storage
    const paymentInfosString = localStorage.getItem("paymentInfos");
    const secret_key = JSON.parse(paymentInfosString).secret_key;
    console.log("secret key", secret_key);

    // Confirm card payment with Stripe
    const paymentResult = await stripe.confirmCardPayment(secret_key, {
      payment_method: {
        card: elements.getElement(CardElement),
      },
    });

    console.log("paymentResult", paymentResult);

    // Handle payment result
    if (paymentResult.error) {
      console.error("Error creating PaymentMethod:", paymentResult.error);
      setPaymentError(paymentResult.error.message);
      setPaymentLoading(false);
      localStorage.removeItem("paymentInfos");
      navigate("/market-place/cart");
    } else {
      console.log("successful payment", paymentResult);
      if (paymentResult.paymentIntent.status === "succeeded") {
        setPaymentLoading(false);
        navigate("/payment-verification");
      } else {
        setPaymentError(paymentResult.paymentIntent.status);
        setPaymentLoading(false);
        localStorage.removeItem("paymentInfos");
        navigate("/market-place/cart");
      }
    }
  };

  return (
    <>
      <NavBar />
      <HeroSm title={lang("t8")} />

      <div className="container my-5 py-10">
        {isLoading ? ( // Show loading spinner if isLoading is true
          <div className="d-flex justify-content-center align-items-center">
            <Spinner size={3} />
          </div>
        ) : (
          <div className="row justify-content-center text-center ">
            <div className="col-md-6">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="card-title text-center text-primary mb-4">
                    Complete your payment with Stripe
                  </h5>
                  {/* Display error message if any */}
                  {paymentError && (
                    <div className="alert alert-danger mt-2" role="alert">
                      {paymentError}
                    </div>
                  )}
                  {/* Payment form */}
                  <form onSubmit={handleSubmit} className="needs-validation">
                    <div className="form-group mb-3">
                      <CardElement
                        className="form-control"
                        options={{
                          style: {
                            base: {
                              backgroundColor: "white",
                            },
                          },
                        }}
                      />
                    </div>
                    {/* Payment button */}
                    <button
                      type="submit"
                      className="btn btn-success btn-block w-100 "
                      disabled={isPaymentLoading}
                    >
                      {isPaymentLoading ? "Processing..." : "Pay"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default StripePayment;
